import React, { useMemo } from "react";
import { withTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import { get, isBoolean, isNumber } from "lodash";
import PropTypes from "prop-types";

import Collapse from "./Collapse";

const mapBooleanToYesNo = (value) => {
  if (typeof value === "boolean") {
    return value ? "Yes" : "No";
  }
  return "-";
};

const UtilityMechanicalSystemView = ({
  utilityMechanicalSystem,
  isExpandable = true,
  isTracking = false,
  t,
}) => {
  const {
    isServiceDuct,
    isServiceDuctsEnclosed,
    numberOfPassengerLift,
    numberOfFireLift,
    isAutomaticRescueDeviceForLift,
    numberOfNaturalVentilation,
    numberOfMechanicalVentilation,
    otherBuildingSystem,
  } = utilityMechanicalSystem;
  const fields = useMemo(
    () => [
      {
        name: "Are there any service ducts in this building block?",
        key: "isServiceDuct",
        renderField: (value) => mapBooleanToYesNo(value),
        isVisible: isTracking ? isBoolean(isServiceDuct) : true,
      },
      {
        name: "Have internal service ducts and shafts been properly enclosed by fire resistant walls and doors, and fire stopped at all floor levels?",
        key: "isServiceDuctsEnclosed",
        renderField: (value) => mapBooleanToYesNo(value),
        isVisible: isTracking ? isBoolean(isServiceDuctsEnclosed) : true,
      },
      {
        name: "No of Passenger Lifts",
        key: "numberOfPassengerLift",
        isVisible: isTracking ? isNumber(numberOfPassengerLift) : true,
      },
      {
        name: "No of Fire Lifts",
        key: "numberOfFireLift",
        isRequired: true,
        isVisible: isTracking ? isNumber(numberOfFireLift) : true,
      },
      {
        name: "Is automatic rescue device provided for lifts?",
        key: "isAutomaticRescueDeviceForLift",
        renderField: (value) => mapBooleanToYesNo(value),
        isVisible: isTracking
          ? isBoolean(isAutomaticRescueDeviceForLift)
          : true,
      },
      {
        name: "Number of Natural Ventilation",
        key: "numberOfNaturalVentilation",
        isRequired: true,
        isVisible: isTracking ? isNumber(numberOfNaturalVentilation) : true,
      },
      {
        name: "Number of Mechanical Ventilation",
        key: "numberOfMechanicalVentilation",
        isRequired: true,
        isVisible: isTracking ? isNumber(numberOfMechanicalVentilation) : true,
      },
      {
        name: "Other Building System",
        key: "otherBuildingSystem",
        isRequired: false,
        isVisible: isTracking ? !!otherBuildingSystem : true,
      },
    ],
    [
      isServiceDuct,
      isServiceDuctsEnclosed,
      numberOfPassengerLift,
      numberOfFireLift,
      isAutomaticRescueDeviceForLift,
      numberOfNaturalVentilation,
      numberOfMechanicalVentilation,
      otherBuildingSystem,
    ]
  );

  const isCollapseVisible = useMemo(
    () => fields.some(({ isVisible }) => isVisible),
    [fields]
  );

  return (
    <>
      {isCollapseVisible && (
        <Collapse
          title="Utility And Mechanical System"
          isExpandable={isExpandable}
        >
          <Row className="d-flex mb-2">
            {fields.map(({ isVisible, name, key, isRequired, renderField }) => {
              const value = get(utilityMechanicalSystem, key, "");
              if (typeof isVisible !== "boolean" || isVisible) {
                return (
                  <Col key={key} lg={6} className="mb-1">
                    <Row>
                      <Col md={5}>{t(name)}:</Col>
                      <Col
                        md={7}
                        className="fw-semibold"
                        style={{ wordBreak: "break-word" }}
                      >
                        {renderField
                          ? renderField(value)
                          : get(utilityMechanicalSystem, key, null) ??
                            (isRequired ? "-" : "N/A")}
                      </Col>
                    </Row>
                  </Col>
                );
              }
            })}
          </Row>
        </Collapse>
      )}
    </>
  );
};

UtilityMechanicalSystemView.propTypes = {
  utilityMechanicalSystem: PropTypes.object,
  isExpandable: PropTypes.bool,
  isTracking: PropTypes.bool,
  t: PropTypes.func,
};

export default withTranslation()(UtilityMechanicalSystemView);
